import { z } from 'zod';
// Environment Configuration Schema
export const EnvConfigSchema = z.object({
    DYNAMODB_TABLE_ARN: z.string().startsWith('arn:aws:dynamodb:'),
    HOSTED_ZONE_ID: z.string().regex(/^Z[A-Z0-9]+$/),
    DOMAIN_NAME: z.string().default('lms.sandboxstudiosoftware.com'),
    CERTIFICATE_ARN: z.string().startsWith('arn:aws:acm:'),
    NOTIFICATION_EMAIL: z.string().email(),
    SES_FROM_EMAIL: z.string().email(),
    GOOGLE_CLIENT_ID: z.string().min(1),
    GOOGLE_CLIENT_SECRET: z.string().min(1),
});
// Validate and parse environment variables
export const validateEnvConfig = (env) => {
    try {
        return EnvConfigSchema.parse(env);
    }
    catch (error) {
        if (error instanceof z.ZodError) {
            const missingFields = error.errors.map(e => e.path.join('.')).join(', ');
            throw new Error(`Environment validation failed. Missing or invalid fields: ${missingFields}`);
        }
        throw error;
    }
};
//# sourceMappingURL=env.schema.js.map